import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css';
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueCarousel from 'vue-carousel'
import VueGeolocation from 'vue-browser-geolocation'
import VueChatScroll from 'vue-chat-scroll'

Vue.config.productionTip = false

Vue.use(Toaster, { timeout: 5000 })
Vue.use(VueSmoothScroll)
Vue.use(VueCarousel);
Vue.use(VueGeolocation);
Vue.use(VueChatScroll)

new Vue({
  render: h => h(App),
}).$mount('#app')
